module.exports = __webpack_public_path__ + "img/read.d05bf2a8.svg";